<!-- eslint-disable vue/multi-word-component-names -->
<script>
import NotificationCUHelper from '@/Helpers/800/notification/notification.cu.helper';
import NotificationCUMixin from '@/Mixins/800/notification/notification.cu.mixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';
import AppPageContainer from '@/components/app/PageContainer.vue';
import TitleHeader from '@/components/app/TitleHeader.vue';
import AppDatePicker from '@/components/app/DatePicker.vue';
import AppBox from '@/components/app/box.vue';
export default {
  components: {
    AppPageContainer,
    TitleHeader,
    AppDatePicker,
    AppBox,
  },
  mixins: [NotificationCUHelper, NotificationCUMixin, UserNotificationMixin],
  methods: {
    fNotifyOutOfService: function () {
      this.onGetAllUserNotificationOnSignal();
    },
  },
  created() {
    this.$root.$refs.NotificationCU = this;
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
};
</script>
<template>
  <app-page-container :title="title" :need-overflow="true">
    <template v-slot:header>
      <v-col cols="2" class="">
        <v-btn fab dark small elevation="1" class="mt-3 mr-n11 darkColor" @click="backToNotificationView">
          <v-icon dark>mdi-arrow-right mdi-24px</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-container fluid class="px-md-8 px-lg-16 px-xl-32">
        <v-row>
          <v-col cols="12">
            <title-header title="اطلاعات اصلی" />
          </v-col>
          <v-col cols="8">
            <v-text-field label="توضیحات" outlined name="description" prepend-inner-icon="mdi-text-box-outline mdi-24px"
              v-model="addOrUpdateForm.text" />
          </v-col>
          <v-col cols="4">
            <app-date-picker inputID="expiration_date" :dense="false" label="تاریخ انقضا"
              v-model="addOrUpdateForm.expirationDate" :const-value="addOrUpdateForm.expirationDate" :is-max="false" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col>
                <title-header title="کد ها" />
              </v-col>
              <v-col><title-header title="کدهای انتخابی" /></v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col>
                <v-row no-gutters class="">
                  <v-col cols="8">
                    <v-text-field label="جست و جو" hide-details outlined rounded dense name="search"
                      append-inner-icon="mdi-text-box-magnify mdi-24px" v-model="searchAllCodesText" />
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center">
                    <v-btn depressed dark outlined raised rounded @click="addAllCodes" class="darkColor">
                      افزودن همه لیست
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row no-gutters class="">
                  <v-col cols="8">
                    <v-text-field hide-details label="جست و جو" outlined rounded dense name="search"
                      append-inner-icon="mdi-text-box-magnify mdi-24px" v-model="searchAddedCodesText" />
                  </v-col>
                  <v-col cols="4" class="d-flex justify-center">
                    <v-btn depressed dark outlined raised rounded @click="clearAllCodes" class="darkColor">
                      حذف همه لیست
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col>
                <app-box outlined>
                  <section class="inner-box">
                    <v-chip-group column>
                      <v-chip v-for="{ code, id } in filterdAllCodes" :key="id" :ripple="false" label dark
                        :disabled="haveBeenAdded(id)" class="all-chip" @click="addNewCode(id)">
                        <v-row no-gutters class="items-baseline">
                          <v-col cols="10">
                            <div>{{ code }}</div>
                          </v-col>
                          <v-col cols="2">
                            <v-icon left dark class="primary-color">mdi-plus mdi-24px</v-icon>
                          </v-col>
                        </v-row>
                      </v-chip>
                    </v-chip-group>
                  </section>
                </app-box>
              </v-col>
              <v-col>
                <app-box outlined>
                  <section class="inner-box">
                    <v-chip-group column>
                      <v-chip v-for="{ code, id } in filterdSelectedAddedCodes" :key="id" :ripple="false" label dark
                        class="darkColor" @click="deleteAddedCode(id)">
                        <v-row no-gutters class="items-baseline">
                          <v-col cols="11">
                            <div>{{ code }}</div>
                          </v-col>
                          <v-col cols="1">
                            <v-icon left>mdi-minus mdi-18px</v-icon>
                          </v-col>
                        </v-row>
                      </v-chip>
                    </v-chip-group>
                  </section>
                </app-box>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="py-8">
          <v-spacer></v-spacer>
          <v-btn v-if="isEditPage" color="darkColor" small ref="yes" rounded
            class="normal-letter-spacing px-12 py-4 ml-2" style="color: white" @click="editNotfication()">
            ویرایش
          </v-btn>
          <v-btn v-else color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
            style="color: white" @click="addNotification()">
            افزودن
          </v-btn>
          <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
            @click="backToNotificationView()">
            انصراف
          </v-btn>
        </v-row>
      </v-container>
    </template>
  </app-page-container>
</template>
<style lang="scss">
.inner-box {
  overflow-y: auto;
  height: 230px;
}

.all-chip {
  background-color: var(--background-color) !important;
  color: var(--v-darkColor-base) !important;
}
</style>
